import { TeamSettingEntity } from '../team/team-setting-entity';
import { TimePart } from '../../infrastructure/time-part';

export class SchedulerCreateEntity {
    public optimizeByTeamTotalTime: boolean = false;
    public allowGamesInAdjacentIntervals: boolean = true;
    public maxExtraIntervals: number = -1; // -1 = Auto
    public startTime: TimePart = null;
    public periodLength: number = 15;
    public gamePause: number = 5;
    public periodPause: number = 5;
    public periods: number = 2;
    public fields: number = 2;
    public teamSettings: TeamSettingEntity[] = [];
    public teamDistributionStrategy: number = 0; // 0 = Optimized, 1 = Distributed

    public toDto(): any {
        return {
            optimizeByTeamTotalTime: this.optimizeByTeamTotalTime,
            allowGamesInAdjacentIntervals: this.allowGamesInAdjacentIntervals,
            fields: this.fields,
            gamePause: this.gamePause,
            maxExtraIntervals: Number(this.maxExtraIntervals),
            periodLength: this.periodLength,
            periodPause: this.periodPause,
            periods: this.periods,
            startTime: this.startTime.toISOString(),
            teamDistributionStrategy: parseInt(String(this.teamDistributionStrategy), 10) || 0,
            teamSettings: TeamSettingEntity.fromDtoArray(this.teamSettings)
        };
    }
}
